export default __webpack_public_path__ + "static/media/06.5ded568d.jpg";